import React from 'react';
import PropTypes from 'prop-types';

const LiveBeachCameras = () => {
  const cameras = [
    {
      name: 'Cape San Blas - Rish Park',
      url: 'https://g1.ipcamlive.com/player/player.php?alias=5e3c25e6e0e2f',
      description: 'Live view of Cape San Blas beach conditions',
      isIframe: true
    },
    {
      name: 'St. Joseph Peninsula State Park',
      url: 'https://www.floridastateparks.org/parks-and-trails/st-joseph-peninsula-state-park',
      description: 'Click to check park webcam and conditions',
      isIframe: false
    },
    {
      name: 'Port St. Joe Marina',
      url: 'https://g1.ipcamlive.com/player/player.php?alias=portstjoemarina',
      description: 'Marina conditions and boat traffic',
      isIframe: true
    }
  ];

  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <h3 className="font-semibold text-lg mb-4 dark:text-gray-100">📹 Live Beach Cameras</h3>
      
      {cameras.map((camera, index) => (
        <div key={index} className="mb-4">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 animate-fade-in">
            {camera.name}
          </h4>
          
          {camera.isIframe ? (
            <div className="relative rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-700" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src={camera.url}
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allowFullScreen
                title={camera.name}
                loading="lazy"
              />
            </div>
          ) : (
            <div className="relative rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-700">
              <a 
                href={camera.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block p-8 text-center hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {camera.description}
                </p>
              </a>
            </div>
          )}
          
          {camera.isIframe && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              {camera.description}
            </p>
          )}
        </div>
      ))}
      
      <div className="text-sm text-gray-600 dark:text-gray-400 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
        <p className="font-medium text-blue-800 dark:text-blue-200 mb-1">📹 Webcam Tips:</p>
        <ul className="text-xs space-y-1">
          <li>• Cameras may take a moment to load</li>
          <li>• Some cameras have limited hours of operation</li>
          <li>• Check multiple views for best beach assessment</li>
        </ul>
      </div>
    </div>
  );
};

LiveBeachCameras.propTypes = {};

export default LiveBeachCameras;